import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    _root: {
        marginLeft: (props) => props.isNarrowWidth ? 5 : '170px',
        padding: '0 24px',
    }
}));
